import { render, staticRenderFns } from "./CertManage.vue?vue&type=template&id=ba9d7778&scoped=true&"
import script from "./CertManage.vue?vue&type=script&lang=js&"
export * from "./CertManage.vue?vue&type=script&lang=js&"
import style0 from "./CertManage.vue?vue&type=style&index=0&id=ba9d7778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9d7778",
  null
  
)

export default component.exports